import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";

import { useSearchParams } from "react-router-dom";

import Typography from "@mui/material/Typography";

import { CircularProgress } from "@mui/material";

import CandleChart from "../Components/CandleChart";
import { getTreemapSymbols } from "../Service/data";
import TimeControl from "../Components/TimeControl";
import IndicatorSelector from "../Components/IndicatorSelector";

const HeatmapsChartPage = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [noData, setNoData] = useState(true);

  let [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const name = searchParams.get("name") || "";
    const category = searchParams.get("category") || "";

    if (name.length !== 0 || category.length !== 0) {
      getTreemapSymbols(name, category).then((data) => {
        setData(data);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (data !== undefined && data !== null && data.length > 0) {
      setLoading(false);
      setNoData(false);
    }
  }, [data]);

  const theme = useTheme();
  return (
    <div
      style={{
        paddingLeft: "20px",
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        minWidth: "100vw",
        background: `${theme.palette.background.default}`,
      }}
    >  
        <Typography variant="h3" color={"white"}>{searchParams.get("name") || ""}</Typography>
        <Typography variant="h5" color={"white"}>{searchParams.get("category") || ""}</Typography>
        <TimeControl/>
        <IndicatorSelector/>
      {loading && <CircularProgress />}
      {noData ? (
        <Typography>No data was received</Typography>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
          }}
        >
          {data.map((item, index) => (
            <div key={`${item}_${index}`}>
            <CandleChart
                  key={`${index}_${item}`}
                  title={item}
                  width={600}
                  height={600}
                  renderOptions={true}
                  onRemove={()=>{}}
                ></CandleChart>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default HeatmapsChartPage;
